import { useState, useCallback } from 'react';

interface Toast {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

interface ToastState extends Toast {
  id: number;
}

let toastId = 0;

// Hook simples de toast - as notificações são mostradas via console por enquanto
// TODO: Implementar componente Toast visual
export function useToast() {
  const toast = useCallback(({ title, description, variant }: Toast) => {
    const id = ++toastId;

    // Log para debug - pode ser substituído por um toast visual
    if (variant === 'destructive') {
      console.error(`[Toast Error] ${title}: ${description || ''}`);
    } else {
      console.log(`[Toast] ${title}: ${description || ''}`);
    }

    // Opcional: mostrar alert para erros críticos em desenvolvimento
    // if (variant === 'destructive' && process.env.NODE_ENV === 'development') {
    //   alert(`${title}\n${description || ''}`);
    // }

    return { id, dismiss: () => {} };
  }, []);

  return { toast };
}
